/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="memberships.module.ts" />

module Meevo.Plugins.Memberships {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    class MembershipsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public objectState;

        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "$http",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',

            "meevo.components.busy.BusyService",
            "$translate",
            '$q'
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected $http: angular.IHttpService,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: angular.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.objectState = ObjectStateEnum;
        }


        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.MEMBERSHIP_MEMBERSHIP).then(() => {
                vm.busyService.stop();
                vm.context = new MembershipsContext(this.$scope, this.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, this.busyService, this.$translate, this.$q);
                vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
                vm.context.deactivate = () => {
                    vm.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).catch(() => {
                vm.busyService.stop();
            });
        }
    }

    angular.module("meevo.plugins.memberships")
        .controller("meevo.plugins.memberships.MembershipsController", MembershipsController);
}
